module.exports = __webpack_public_path__ + "static/logo-51a4b6b9808db0cfb64f9c2fba84985c.png";